import { useEasyModeContext } from '../../contexts/EasyModeContext';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XResizableTextarea from '../common/XResizableTextarea';
import EasyModeDefendantPanel from './EasyModeDefendantPanel';
import {
  contextCounterAtLimitClasses,
  contextCounterClasses,
  contextExampleLabelClasses,
  contextExampleListClasses,
  contextFieldClasses,
  contextFooterClasses,
  contextHelperClasses,
  fieldErrorClasses,
  stepBodyClasses
} from './easyModeClasses';

const EasyModeContextStep = () => {
  const { contextStep } = useEasyModeContext();
  const usedLength = contextStep.additionalContext.length;
  const isAtLimit = usedLength >= contextStep.maxLength;

  return (
    <div className={stepBodyClasses} data-tour={TOUR_TARGETS.EASY_MODE_CONTEXT}>
      <XResizableTextarea
        label="Any additional important information for this case? (optional)"
        name="additionalContext"
        value={contextStep.additionalContext}
        placeholder="Any additional context you have about the case"
        minHeight="6rem"
        maxLength={contextStep.maxLength}
        className={contextFieldClasses}
        onChange={contextStep.handleChange}
        onBlur={contextStep.handleBlur}
      />
      <div className={contextHelperClasses}>
        Any additional context you have about the case?
        <ul className={contextExampleListClasses}>
          <li>
            <span className={contextExampleLabelClasses}>Example 1: </span>
            The defendant immediately admitted fault upon exiting the vehicle, stating, "I'm so sorry, I
            was looking down at my GPS."
          </li>
          <li>
            <span className={contextExampleLabelClasses}>Example 2: </span>
            A knee fracture forced the plaintiff to forfeit the Chicago Marathon after a year of training,
            ending their ability to jog or hike with family.
          </li>
        </ul>
      </div>
      <div className={contextFooterClasses}>
        {contextStep.error && <span className={fieldErrorClasses}>{contextStep.error}</span>}
        <span className={isAtLimit ? contextCounterAtLimitClasses : contextCounterClasses}>
          {`${usedLength} / ${contextStep.maxLength}`}
        </span>
      </div>
      <EasyModeDefendantPanel />
    </div>
  );
};

export default EasyModeContextStep;
